import axios from "axios";
import { ServiceURL } from "@/config/ServiceUrl";
import { store } from "@/redux/store";

const axiosInstance = axios.create({
  baseURL: ServiceURL.API_URL,
  // headers: {
  //   "Content-Type": "application/json",
  // },
});

// Optional: Add interceptors for token
axiosInstance.interceptors.request.use((config) => {
   const token = store.getState().auth.token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});



export default axiosInstance;
